import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { SettingTypeEnum, SettingApplicationEnum } from "@/domain/setting.enum";

const validationSchema = (t: TFunction) => {
  return yup.object().shape({
    product: yup
      .string()
      .required(t("validations.required"))
      .max(100, t("validations.max_length", { count: 100 })),
    application: yup
      .string()
      .required(t("validations.required"))
      .oneOf(
        Object.values(SettingApplicationEnum),
        t("validations.invalid_format"),
      )
      .max(100, t("validations.max_length", { count: 100 })),
    module: yup
      .string()
      .required(t("validations.required"))
      .max(100, t("validations.max_length", { count: 100 })),
    section: yup
      .string()
      .required(t("validations.required"))
      .max(100, t("validations.max_length", { count: 100 })),
    name: yup
      .string()
      .required(t("validations.required"))
      .min(2, t("validations.min_length", { count: 2 }))
      .max(100, t("validations.max_length", { count: 100 })),
    description: yup
      .string()
      .required(t("validations.required"))
      .max(500, t("validations.max_length", { count: 500 })),
    type: yup
      .string()
      .required(t("validations.required"))
      .oneOf(Object.values(SettingTypeEnum), t("validations.invalid_format")),
    default: yup
      .mixed()
      .required(t("validations.required"))
      .test(
        "is-valid-array",
        t("validations.invalid_format") || "Must be a valid JSON array",
        function (value) {
          const { type } = this.parent;
          if (type === SettingTypeEnum.ARRAY) {
            if (typeof value === "string") {
              try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed);
              } catch {
                return false;
              }
            }
            return Array.isArray(value);
          }
          return true;
        },
      ),
    value: yup
      .mixed()
      .optional()
      .test(
        "is-valid-array",
        t("validations.invalid_format") || "Must be a valid JSON array",
        function (value) {
          const { type } = this.parent;
          if (
            type === SettingTypeEnum.ARRAY &&
            value !== undefined &&
            value !== null &&
            value !== ""
          ) {
            if (typeof value === "string") {
              try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed);
              } catch {
                return false;
              }
            }
            return Array.isArray(value);
          }
          return true;
        },
      ),
    active: yup.boolean().required(t("validations.required")),
  });
};

export type SettingFormData = InferType<ReturnType<typeof validationSchema>>;

export default validationSchema;
